import { Box, IconButton, Modal, Typography } from "@mui/material";
import AddResume from "../resume-builder/AddResume";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";

const ResumeBuilderModal = ({
  open,
  onClose,
  setOpenResumeBuilder,
  fetchResumes,
  loadApi,
  setErrorMessage
}) => {
  const handleClose = () => {
    setOpenResumeBuilder(false);
    fetchResumes();
  };
  const { multiLanguageData } = useSelector((state) => state?.main);

  const LanguageData = multiLanguageData?.JobPostings || {};

  const { RESUME_BUILDER = English.JobPostings.RESUME_BUILDER } = LanguageData || {};
  return (
    <Modal open={open} onClose={onClose}>
      <Box className="user-modal-responsive2">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6">{RESUME_BUILDER}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box>
          <AddResume
            fromJob={"apply-job"}
            onClose={handleClose}
            fetchResumes={fetchResumes}
            setOpenResumeBuilder={setOpenResumeBuilder}
            loadApi={loadApi}
            setErrorMessage={setErrorMessage}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ResumeBuilderModal;
